// extracted by mini-css-extract-plugin
export default {"public-page-feed":"public-page-feed--2amJM","public-page-feed__content":"public-page-feed__content--AeMcn","public-page-feed__content__feed":"public-page-feed__content__feed--QYN-J","public-page-feed__aux-col":"public-page-feed__aux-col--2s0yQ","public-page-feed__goto":"public-page-feed__goto--uT5i0"};
    if(module.hot) {
      // 1744795003910
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  